












































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { Validator } from 'vee-validate';

import ColorSelector from '@/components/App/Catalog/ColorSelector.vue';

@Component({
    components: {
        'app-color-selector': ColorSelector,
    },
})
export default class ProductOption extends Vue {
    @Inject('validator')
    public $validator!: Validator;

    @Prop()
    public option!: any;

    public hasError () {
        if (this.isWidth()) {
            return this.$validator.errors.has('width');
        } else if (this.isHeight()) {
            return this.$validator.errors.has('height');
        }
        
        return this.$validator.errors.has(String(this.option.id));
    }

    public isSelect () {
        return this.option.type === 'INPUT_SELECT' || this.option.type === 'DELIVERY';
    }

    public isNumber () {
        return this.option.type === 'INPUT_NUMBER';
    }

    public isWidth () {
        return this.option.type === 'INPUT_WIDTH';
    }

    public isHeight () {
        return this.option.type === 'INPUT_HEIGHT';
    }

    public isColor () {
        return this.option.type === 'COLOR';
    }

    public onChanged () {
        this.$emit('valueChanged');
    }
}
